import React from "react"

import { Centered } from "../../simple";

import styles from "./style.module.css"
import logo from "./logo.svg"

const elements = {
    Top: require("./scene-elements/top-element.svg"),
    CenterLeft: require("./scene-elements/center-left-element.svg"),
    CenterRight: require("./scene-elements/center-right-element.svg"),
    BottomLeft: require("./scene-elements/bottom-left-element.svg"),
    BottomRight: require("./scene-elements/bottom-right-element.svg"),
    FarBack: require("./scene-elements/far-back-element.svg")
}

const SceneElement = ({ name }) => (
    <img className={styles[`sceneElement${name}`]} alt={name} src={elements[name]} />
)

const Scene = () => (
    <div className={styles.scene}>
        {Object.keys(elements).sort().map(e => (
            <SceneElement key={e} name={e} />
        ))}
    </div>
)

export default () => (
    <Centered className={[styles.body, "fillScreen flex-column"].join(" ")}>
        <Scene />
        <div className={[styles.logoWrapper, "mt-4"].join(" ")}>
            <img src={logo} alt="ethronsoft logo" className="img-fluid" />
        </div>
    </Centered>
)


// WEBPACK FOOTER //
// ./src/components/complex/Splash/index.js